<label [class]="wrapperClass()">
  <input
    type="checkbox"
    class="bz-checkbox__input"
    [checked]="checked()"
    [indeterminate]="indeterminate()"
    [disabled]="disabled()"
    [attr.aria-label]="ariaLabel() || null"
    (change)="toggle()"
    (blur)="markTouched()"
  />
  <span class="bz-checkbox__label"><ng-content /></span>
</label>
